module.exports = __webpack_public_path__ + "static/media/DC_O_Fashion_Sempione.0de3ca4a.png";